const http = require('../lib/httpClient');
const { getCookie, getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { COOKIES, COMMERCE_HEADER } = require('../constants');

const agentLogoutError = {
  code: 'AGENT_LOGOUT_ERROR',
  message: 'Unable to logout',
};

const endpoint = '/s/auth/v1/agent/logout';

async function agentLogout(tenantId, agentBaseUrl = '', additionalInfo = {}) {
  const sessionId = getCookie(COOKIES.AGENT_SESSION.VALUE);
  if (!sessionId) {
    return {
      success: false,
      errors: [{ code: 'LOGOUT_ERROR', message: 'Session not found' }],
    };
  }
  const result = await http.post(
    `${agentBaseUrl}${endpoint}`,
    { sessionId },
    {
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId, additionalInfo),
        'x-commerce': getXCommerceValue(agentBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) return { success: false, errors: [agentLogoutError] };
  const { active, errors } = responseBody;
  if (errors) return { success: false, errors };
  if (active) {
    return {
      success: false,
      errors: [{ code: 'LOGOUT_ERROR', message: 'Unable to logout user' }],
    };
  }
  return { success: true, errors: [] };
}

module.exports = agentLogout;
